import { render, staticRenderFns } from "./ProductsFilter.vue?vue&type=template&id=ba851732&scoped=true"
import script from "./ProductsFilter.vue?vue&type=script&lang=js"
export * from "./ProductsFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba851732",
  null
  
)

export default component.exports